export default __webpack_public_path__ + "static/media/Dina-Dehaini.467080ac.pdf";